import React from 'react';

export const useOtpResendCountdown = (): {secondsToResend: number, countdown: string, setSecondsToResend: (secs: number) => void} => {
  const [secondsToResend, setSecondsToResend] = React.useState<number>(119);

  const minutes = React.useMemo(() => Math.floor(secondsToResend / 60), [secondsToResend]);
  const remainingSeconds = React.useMemo(() => secondsToResend - (minutes * 60), [secondsToResend, minutes]);
  const countdown = React.useMemo(() => `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`, [minutes, remainingSeconds]);

  React.useEffect(() => {
    const timerId = setInterval(() => {
      setSecondsToResend((prev) => {
        if (prev) {
          return prev - 1;
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return {
    countdown,
    secondsToResend,
    setSecondsToResend,
  };
};
